var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocuemntsActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "j"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.8125 5C11.8125 4.94 11.7975 4.88 11.775 4.82C11.6925 4.2125 11.4225 3.6275 10.9875 3.1925L9.3075 1.5125C8.8575 1.0625 8.2875 0.8 7.6725 0.725C7.62 0.71 7.56 0.6875 7.5 0.6875C7.4775 0.6875 7.4625 0.695 7.44 0.7025C7.395 0.7025 7.3575 0.6875 7.32 0.6875H3C1.4475 0.6875 0.1875 1.9475 0.1875 3.5V12.5C0.1875 14.0525 1.4475 15.3125 3 15.3125H9C10.5525 15.3125 11.8125 14.0525 11.8125 12.5V5.18C11.8125 5.1425 11.805 5.0975 11.7975 5.06C11.7975 5.0375 11.8125 5.0225 11.8125 5ZM10.1925 3.9875C10.32 4.115 10.425 4.2725 10.5075 4.4375H8.25C8.145 4.4375 8.0625 4.355 8.0625 4.25V1.9925C8.2275 2.075 8.3775 2.1725 8.5125 2.3075L10.1925 3.9875ZM9 14.1875H3C2.07 14.1875 1.3125 13.43 1.3125 12.5V3.5C1.3125 2.57 2.07 1.8125 3 1.8125H6.9375V4.25C6.9375 4.97 7.53 5.5625 8.25 5.5625H10.6875V12.5C10.6875 13.43 9.93 14.1875 9 14.1875Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9 6.6875H3C2.6925 6.6875 2.4375 6.9425 2.4375 7.25C2.4375 7.5575 2.6925 7.8125 3 7.8125H9C9.3075 7.8125 9.5625 7.5575 9.5625 7.25C9.5625 6.9425 9.3075 6.6875 9 6.6875Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9 8.9375H3C2.6925 8.9375 2.4375 9.1925 2.4375 9.5C2.4375 9.8075 2.6925 10.0625 3 10.0625H9C9.3075 10.0625 9.5625 9.8075 9.5625 9.5C9.5625 9.1925 9.3075 8.9375 9 8.9375Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6 11.1875H3C2.6925 11.1875 2.4375 11.4425 2.4375 11.75C2.4375 12.0575 2.6925 12.3125 3 12.3125H6C6.3075 12.3125 6.5625 12.0575 6.5625 11.75C6.5625 11.4425 6.3075 11.1875 6 11.1875Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuemntsActivity);
export default __webpack_public_path__ + "static/media/docuemnts-activity.fe6ed0b3171db03dffc0d6c43aa60f95.svg";
export { ForwardRef as ReactComponent };